// 공통적으로 사용할 수 있는 함수 (comma, empty 등등)
const utils = {
    isEmpty(val) {
        return val === null || val === undefined || val === 'undefined' || typeof val === 'undefined' || String(val).trim() === '';
    },
    comma(val) {
        if (typeof val === 'undefined') val = 0;

        const sValue = String(val);
        let parts = sValue.split('.');
        let regex = new RegExp(`\\B(?=(\\d{${3}})+(?!\\d))`, 'g');

        return parts[0].replace(regex, ',') + (parts[1] ? '.' + parts[1] : '');
    },
    nowDate() {
        const today = new Date();

        const year = today.getFullYear();
        const month = ('0' + (today.getMonth() + 1)).slice(-2);
        const day = ('0' + today.getDate()).slice(-2);

        return year + '-' + month  + '-' + day;
    },
    nowDay() {
        const today = new Date();
        const weekDay = ['일', '월', '화', '수', '목', '금', '토'];

        return weekDay[today.getDay()];
    },
    nowTime() {
        const today = new Date();

        const hours = ('0' + today.getHours()).slice(-2);
        const minutes = ('0' + today.getMinutes()).slice(-2);
        const seconds = ('0' + today.getSeconds()).slice(-2);

        return hours + ':' + minutes  + ':' + seconds;
    },





    changeDateFormat(val, type) {
        if (!val) return;
        type = this.isEmpty(type) ? 'YYYY-MM-DD' : type;
        return moment(val).format(type);
    },
    rowNo(index, totalCount, perPage, currentPage) {
        const indexNo = totalCount - index - perPage * (currentPage - 1);
        return indexNo;
    },









    textLengthOverCut(text, len, lastText) {
        len = this.isEmpty(len) ? 20 : len;
        lastText = this.isEmpty(lastText) ? '...' : lastText;

        if (!this.isEmpty(text) && text.length > len) {
            text = text.substr(0, len) + lastText;
        }
        return text;
    },



    // for datepicker
    periodOneMonth(emit, fromDate) {
        let start;
        let end;

        if (fromDate === 'today') {
            start = moment().subtract(1, 'months').toDate();
            end = moment().toDate();
        } else if (fromDate === 'yesterday') {
            start = moment(moment().subtract(1, 'days')).subtract(1, 'months').toDate();
            end = moment().subtract(1, 'days').toDate();
        }

        return emit([start, end]);
    },
    periodThreeMonth(emit, fromDate) {
        let start;
        let end;

        if (fromDate === 'today') {
            start = moment().subtract(3, 'months').toDate();
            end = moment().toDate();
        } else if (fromDate === 'yesterday') {
            start = moment(moment().subtract(1, 'days')).subtract(3, 'months').toDate();
            end = moment().subtract(1, 'days').toDate();
        }

        return emit([start, end]);
    },
    periodSixMonth(emit, fromDate) {
        let start;
        let end;

        if (fromDate === 'today') {
            start = moment().subtract(6, 'months').toDate();
            end = moment().toDate();
        } else if (fromDate === 'yesterday') {
            start = moment(moment().subtract(1, 'days')).subtract(6, 'months').toDate();
            end = moment().subtract(1, 'days').toDate();
        }

        return emit([start, end]);
    }
}

export default {
    install(Vue) {
        Vue.prototype.$_utils = utils
    }
}
